const dashboardPanels = {

  // Patient
  patient: {
    title: `Patient`,
    role: [
      1,
    ],
    links: [
      {
        title: `My Requests`,
        link: `dashboard-requests`,
      },
    ],
  },
  dentist: {
    title: `Doctor`,
    role: [
      2,
      3,
    ],
    links: [
      {
        title: `My Procedures and X-Ray Requests`,
        link: `dashboard-requests`,
      },
      {
        title: `My Location(s)`,
        link: `dashboard-dentist-locations`,
      },

    ],
  },

  // Reviewer
  reviewer: {
    title: `Reviewer`,
    role: [
      3,
    ],
    links: [
      {
        title: `Reviews`,
        link: `dashboard-reviews`,
      },
    ],
  },

  // Admin
  admin: {
    title: `Admin`,
    role: [
      42,
    ],
    links: [
      // {
      //   title: `Procedure Reviews`,
      //   link: `dashboard-requests`,
      // },
      // {
      //   title: `VeriTooth Dentists`,
      //   // link: `admin-veritooth-dentists`,
      // },
      // {
      //   title: `VeriTooth Patients`,
      //   // link: `admin-veritooth-patients`,
      // },
      {
        title: `Reviewer Verification`,
        link: `admin-reviewer-requests`,
      },
      {
        title: `Email Logs`,
        link: `admin-email-logs`,
      },
    ],
  },

  // Profile
  profile: {
    title: `Profile`,
    role: true,
    links: [
      {
        title: `My Information`,
        link: `dashboard-profile-info`,
      },
      {
        title: `Password`,
        link: `dashboard-profile-password`,
      },
    ],
  },
};

export default dashboardPanels;



// WEBPACK FOOTER //
// ./client/models/dashboard/navigation.js